import React from 'react';
import classes from './SlateLink.module.scss';
import { RenderElementProps, useFocused, useSelected, useSlateStatic } from 'slate-react';
import { Node, Element } from 'slate';
import { CustomLink } from 'models/slate-editor';
import classNames from 'classnames';

export interface SlateLinkViewProps extends RenderElementProps {
  element: CustomLink;
}

export const SlateLinkView = ({ attributes, element, children }: SlateLinkViewProps): JSX.Element => {
  const selected = useSelected();
  const focused = useFocused();
  const editor = useSlateStatic();
  let isSelectedOnly = false;

  const { selection } = editor;
  // Get selected fragment and check if fragment include selected link only
  const selectedElements = selected && selection && Node.fragment(editor, selection);
  if (
    selectedElements &&
    selectedElements.length === 1 &&
    Element.isElement(selectedElements[0]) &&
    selectedElements[0].children.length === 1 &&
    Element.isElement(selectedElements[0].children[0])
  ) {
    isSelectedOnly = true;
  }

  return (
    <span
      {...attributes}
      contentEditable={false}
      data-cy={`link-${element.initialUrl.replace(/[^\w-]+|\s/g, '-')}`}
      className={classNames(classes.SlateLink, {
        [classes.SlateLinkSelected]: selected && focused,
        [classes.SlateLinkSelectedVoid]: isSelectedOnly && focused
      })}>
      {element.initialUrl}
      {children}
    </span>
  );
};
